import type { GiantId } from '../../../domain/ids/ids';
import {
  formatGiantOrderLevelName,
  getGiantDisplayName,
  getGiantOrder,
} from '../../../domain';

export type DeliveryDialogContent = {
  levelNameText: string;
  giantNameText: string;
  riddleText: string;
  deliveryItemText: string;
  answerText: string;
};

export function deliveryDialogContentForGiant(
  giantId: GiantId,
  orderIndex = 0,
): DeliveryDialogContent {
  const order = getGiantOrder({ giantId, orderIndex });

  return {
    levelNameText: formatGiantOrderLevelName(order.title),
    giantNameText: getGiantDisplayName(giantId),
    riddleText: order.riddle,
    deliveryItemText: order.item,
    answerText: order.answer,
  };
}
